<template>
  <div class="foot-component">
    <div class="promise-container">
      <div>
        <img :src="commend" />
        <div>
          <h4>货真价实</h4>
          <p>价格、库存真实有效，杜绝虚假交易</p>
        </div>
      </div>
      <div>
        <img :src="safety" />
        <div>
          <h4>买卖无忧</h4>
          <p>会员认证、诚信、积分，三大体系保驾护航</p>
        </div>
      </div>
      <div>
        <img :src="service" />
        <div>
          <h4>优质服务</h4>
          <p>专业人员全程一对一服务、贴心呵护</p>
        </div>
      </div>
    </div>
    <div class="foot-middle">
      <div>
        <a>免责声明</a>
        <span class="line"></span>
        <a>交易规则</a>
        <span class="line"></span>
        <a>交易流程</a>
        <span class="line"></span>
        <a>法律声明</a>
        <span class="line"></span>
        <a>隐私声明</a>
      </div>
      <div v-html="copyright">
        <!-- <span>©2016—2020</span>
        <span>中联钢信电子商务有限公司</span>
        <span>www.zlgx.com</span>
        <span>All Rights Reserved</span>
        <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">京ICP备16034586号-3</a>
        <a href="https://cenpur-pro.oss-cn-beijing.aliyuncs.com/zsteel_licence_20181126.jpg" target="_blank">&nbsp;&nbsp;&nbsp;营业执照</a> -->
      </div>
    </div>
    <!--<div class="img-container">-->
    <!--<img :src="icon1" alt>-->
    <!--<img :src="icon2" alt>-->
    <!--<img :src="icon3" alt>-->
    <!--</div>-->
  </div>
</template>
<script>
import commend from '@/assets/icon_commend.png';
import safety from '@/assets/icon_safety.png';
import service from '@/assets/icon_service.png';
// import icon1 from '@/assets/footer_icon1.png'
// import icon2 from '@/assets/footer_icon2.png'
// import icon3 from '@/assets/footer_icon3.png'

export default {
  name: 'c-foot',
  data() {
    setTimeout(() => {
      let copyright =
        JSON.parse(localStorage.getItem('WEB_INFO')).init.copyright || '';
      this.copyright = copyright;
    }, 500);
    return {
      commend,
      safety,
      service,
      copyright: '',
      // icon1,
      // icon2,
      // icon3
    };
  },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>

<style lang="scss">
.copyright-container {
  > span,
  a {
    font-size: 12px;
  }
  a,
  span {
    margin: 0 10px;
  }
  > a {
    margin-left: 10px;
    color: #999999;
    text-decoration: none;
    cursor: pointer;
  }
}
</style>